import { t } from "@lingui/macro";
import * as Linking from "expo-linking";

import { Button } from "@whoosh/design-system/src/components/controls";
import { Input } from "@whoosh/design-system/src/components/controls/Input";
import { Avatar } from "@whoosh/design-system/src/components/display";
import { ArrowLeftIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
  Pressable,
  ScrollView,
} from "@whoosh/design-system/src/components/primitive";

import { normalizePhoneNumber } from "../../../utils/phone";

type MemberModalSelectedMemberMemberDisplayProps = {
  onClose: () => void;
  fullName: string;
  firstName: string | null;
  lastName: string | null;
  email?: string | null;
  phone?: string | null;
  profileImageId?: string;
};

export const MemberModalSelectedMemberMemberDisplay = ({
  onClose,
  email,
  firstName,
  lastName,
  fullName,
  phone,
  profileImageId,
}: MemberModalSelectedMemberMemberDisplayProps) => {
  const sendEmail = () => {
    if (email) {
      Linking.openURL(`mailto:${email}`);
    }
  };

  const callPhone = () => {
    if (phone) {
      Linking.openURL(`tel:${phone}`);
    }
  };

  return (
    <Box backgroundColor="surface-primary" flex={1} width="100%">
      <Pressable
        backgroundColor="grayscale-100"
        width={56}
        height={56}
        p={5}
        mt={6}
        mx={6}
        style={{ borderRadius: 8 }}
        justifyContent="center"
        alignItems="center"
        onPress={onClose}
      >
        <ArrowLeftIcon color="grayscale-1000" />
      </Pressable>
      <Text pt={8} px={6} pb={6} variant="mainTitle2" color="text-primary">
        {fullName}
      </Text>
      <ScrollView px={6}>
        <Avatar
          profileImagePublicId={profileImageId}
          firstName={firstName}
          lastName={lastName}
          type="member"
          size="lg"
        />
        {email ? (
          <HStack mt={10} gap={2}>
            <Box flexGrow={1} flexShrink={1}>
              <Input
                size="large"
                label={t`Email`}
                name="email"
                value={email}
                isDisabled
                onChange={() => {}}
              />
            </Box>
            <VStack pt={7} flexGrow={0} flexShrink={0}>
              <Button
                accessibilityLabel={t`Email`}
                testID="member-modal-email-button"
                variant={"main"}
                onPress={sendEmail}
              >
                {t`Email`}
              </Button>
            </VStack>
          </HStack>
        ) : null}
        {phone ? (
          <HStack mt={10} gap={2}>
            <Box flexGrow={1} flexShrink={1}>
              <Input
                size="large"
                label={t`phone`}
                name="phone"
                value={normalizePhoneNumber(phone)}
                isDisabled
                onChange={() => {}}
              />
            </Box>
            <VStack pt={7} flexGrow={0} flexShrink={0}>
              <Button
                accessibilityLabel={t`Call`}
                testID="member-modal-email-button"
                variant={"main"}
                onPress={callPhone}
              >
                {t`Call`}
              </Button>
            </VStack>
          </HStack>
        ) : null}
      </ScrollView>
    </Box>
  );
};
